import React, { useEffect, useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { auth } from "../../api";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import { isValidEmail } from "../../utils/helper.jsx";
function PagesLogin() {
  const navigate = useNavigate();
  const { selectedApp, handleChangeApp } = useDashboardContext();
  const { login } = useAuth();
  const context = useContext(AppSettings);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openMultiCompany, setOpenMultiCompny] = useState(false);
  const [openMultiService, setOpenMultiService] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedService, setSelectedService] = useState("CGM");
  const [user, setUser] = useState(null);

  //forgot
  const [email2, setEmail2] = useState("");
  const handleForgot = async (e) => {
    try {
      if (!isValidEmail(email2.trim())) {
        toast.error("A valid email is required!");
        return;
      }
      setLoading(true);
      const response = await auth.forgotPassword(email2.trim().toLowerCase());
      setLoading(false);
      if (response.ok) {
        const body = await response.json();

        if (body.success) {
          //toast.success(body.message);
          toast.success("Please check your email");
          setOpen(false);
        } else {
          toast.error("Email not found");
        }
      } else {
        const body = await response.json();

        let message = body.message;

        toast.error(message);
      }
    } catch (e) {
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);

  const handleChooseCompany = async () => {
    if (email && password && selectedCompany) {
      try {
        setLoading(true);
        const [status, message, data] = await login(
          email.toLowerCase(),
          password,
          selectedCompany
        );

        //console.log({ status, message });

        if (!status) {
          toast.error(message);
          setLoading(false);
        } else {
          if (data.multiService) {
            setOpenMultiCompny(false);
            setOpenMultiService(true);
          } else {
            setOpenMultiCompny(false);
            handleChangeApp(data.service?.service_id);
            setTimeout(() => {
              if (data.service?.service_id === "CMMS") {
                window.location.href = "/work-order/list";
              } else {
                window.location.href = "/machine-health";
              }
            }, 150);
          }
        }
      } catch (e) {
        console.log(e);
        toast.error(e);
        setLoading(false);
      }

      setLoading(false);
    }
  };

  const handleChooseService = () => {
    handleChangeApp(selectedService);
    setTimeout(() => {
      if (selectedService === "CMMS") {
        window.location.href = "/work-order/list";
      } else {
        window.location.href = "/machine-health";
      }
    }, 150);
  };

  async function handleSubmit(event) {
    event.preventDefault();
    if (email && password) {
      try {
        setLoading(true);
        const [status, message, data] = await login(
          email.toLowerCase(),
          password
        );
        //console.log({ status, message });
        if (!status) {
          toast.error(message);
          setLoading(false);
        } else {
          console.log({ data });
          setCompanies(data.companies);
          if (data.companies.length > 1) {
            setOpenMultiCompny(true);
            setSelectedCompany(data.companies[0].company?.id);
            setUser(data);
          } else {
            if (data.multiService) {
              setOpenMultiService(true);
            } else {
              handleChangeApp(data.service?.service_id);
              const is_matar = data?.companies[0]?.company?.is_matar;
              if (is_matar) {
                window.location.href = "/matar-dashboard";
                return;
              }
              setTimeout(() => {
                if (data.service?.service_id === "CMMS") {
                  window.location.href = "/work-order/list";
                } else {
                  window.location.href = "/machine-health";
                }
              }, 150);
            }
          }
          // window.location.href = "/machine-health";
          // navigate("/machine-health");
        }
      } catch (e) {
        //navigate("/machine-health");
        toast.error("Something went wrong, please try again later");
        setLoading(false);
      }

      setLoading(false);
    }
  }
  return (
    <div className="login">
      <ConfirmationDlg
        disableClose={true}
        open={openMultiService}
        onClose={() => setOpenMultiService(false)}
        title={`Hi ${user?.firstname} ${user?.lastname}, Please select a service to continue.`}
        onSubmit={handleChooseService}
        hideCancelBtn={true}
        btnSubmitText={"Proceed"}
      >
        {["CGM", "CMMS"].map((service) => (
          <div key={service} className="form-check">
            <input
              className="form-check-input"
              type="radio"
              id={service}
              name="service"
              checked={selectedService === service}
              value={service}
              onChange={(e) => setSelectedService(e.target.value)}
            />
            <label className="form-check-label" htmlFor={service}>
              {service}
            </label>
          </div>
        ))}
      </ConfirmationDlg>
      <ConfirmationDlg
        disableClose={true}
        open={openMultiCompany}
        setOpen={setOpenMultiCompny}
        onClose={() => setOpenMultiCompny(false)}
        title={`Hi ${user?.firstname} ${user?.lastname}, Please select a company to continue.`}
        onSubmit={handleChooseCompany}
        hideCancelBtn={true}
        btnSubmitText={"Proceed"}
      >
        {companies.map((company) => (
          <div key={company.company?.id} className="form-check">
            <input
              className="form-check-input"
              type="radio"
              id={`company-${company.company?.id}`}
              name="company"
              checked={selectedCompany === company.company?.id}
              value={company.company?.id}
              onChange={(e) => setSelectedCompany(e.target.value)}
            />
            <label
              className="form-check-label"
              htmlFor={`company-${company.company?.id}`}
            >
              {company.company?.company_name}
            </label>
          </div>
        ))}
      </ConfirmationDlg>
      <ConfirmationDlg
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
        title="Forgot Password"
        onSubmit={handleForgot}
        btnSubmitText={"Send Reset Email!"}
        btnCancelText={"Cancel"}
      >
        <div className="mb-3">
          <label className="form-label">
            Email Address <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            required={true}
            value={email2}
            onChange={(e) => setEmail2(e.target.value)}
            className="form-control form-control-lg bg-white bg-opacity-5"
            placeholder=""
          />
        </div>
      </ConfirmationDlg>
      <LoadingIndicator open={loading} />
      <div className="login-content">
        <form onSubmit={handleSubmit}>
          <div className="my-1 text-center">
            <img
              src="/assets/img/logo_white.png"
              alt=""
              className="login-logo"
            />
          </div>
          <div className="text-inverse text-opacity-50 text-center mb-4">
            Please verify your identity.
          </div>
          <div className="mb-3">
            <label className="form-label">
              Email Address <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              required={true}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
          <div className="mb-3">
            <div className="d-flex">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
            </div>
            <input
              type="password"
              required={true}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
          <div className="mb-3 d-flex justify-content-between">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="customCheck1"
              />
              <label className="form-check-label" htmlFor="customCheck1">
                Remember me
              </label>
            </div>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setOpen(true)}
              className=" ms-auto text-inverse text-decoration-none text-opacity-50"
            >
              Forgot password?
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3"
          >
            Sign In
          </button>
          <div className="text-center text-inverse text-opacity-50">
            Don't have an account yet?{" "}
            <Link to="/public-register">Sign up</Link>.
          </div>
        </form>
      </div>
    </div>
  );
}

export default PagesLogin;
